var map = {
	"./1 baby.jpg": 959,
	"./10 cookie and vittorio.jpg": 712,
	"./10a cookie vittorio funeral.jpg": 369,
	"./1a baby.jpg": 872,
	"./2 woman.png": 378,
	"./2a woman.jpg": 861,
	"./3 protest funeral.jpg": 797,
	"./4 conference.png": 466,
	"./4a conference.png": 739,
	"./5 riot stickers.jpg": 193,
	"./6 silence death poster.jpg": 560,
	"./6a david death.png": 423,
	"./7 ryan white.png": 264,
	"./8 blind man piano.jpg": 340,
	"./8a baby.jpg": 601,
	"./9 john and john.png": 860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 282;